import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FaMinus, FaPlus } from "react-icons/fa";

const defaultFaqs = [
  {
    question: "What makes your advertising services unique?",
    answer:
      "Our unique blend of data-driven strategies, creative excellence, and deep market understanding sets us apart. We create customized solutions that deliver measurable results and lasting impact for your brand.",
  },
  {
    question: "How do you measure advertising success?",
    answer:
      "We use comprehensive analytics and KPI tracking to measure campaign performance, including engagement rates, conversion metrics, ROI analysis, and brand sentiment indicators.",
  },
  {
    question: "What industries do you specialize in?",
    answer:
      "We have extensive experience across various sectors including retail, technology, healthcare, and hospitality. Our diverse portfolio enables us to bring cross-industry insights to your campaigns.",
  },
];

export const FAQSection = ({ pageFAQ }) => {
  const [openFAQ, setOpenFAQ] = useState(null);

  return (
    <div className="py-4">
      <div className="container mx-auto px-4">
        <div className="mb-10 text-center sm:mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-4 text-3xl font-bold text-brand-red sm:text-4xl"
          >
            Frequently Asked Questions
          </motion.h2>
          <div className="w-20 h-1 bg-[#bc1535] mx-auto"></div>
        </div>

        <div className="max-w-3xl mx-auto">
          <AnimatePresence>
            {[...(pageFAQ || defaultFaqs)].map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="mb-4"
              >
                <button
                  onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                  className="flex w-full items-center justify-between rounded-xl bg-white p-4 text-left shadow-md transition-all duration-300 hover:shadow-lg sm:p-6"
                >
                  <span className="pr-4 text-base font-semibold text-gray-900 sm:text-lg">
                    {faq.question}
                  </span>
                  <motion.span
                    animate={{ rotate: openFAQ === index ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="text-[#bc1535]"
                  >
                    {openFAQ === index ? <FaMinus /> : <FaPlus />}
                  </motion.span>
                </button>
                <AnimatePresence>
                  {openFAQ === index ? (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <div className="border-t border-gray-100 bg-white p-4 sm:p-6">
                        <p className="text-gray-600 leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>
                  ) : null}
                </AnimatePresence>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};
